/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum GlobalGrant {
  Administrator = 'administrator',
  AuctionManager = 'auction_manager',
  UserManager = 'user_manager',
  BidsManager = 'bids_manager',
  Connector = 'connector',
  SystemAdministrator = 'system_administrator'
}
